export var tabsPrefix = 'listing-card-tabs';
export var tabSelect = 'tab-select';
export var showMore = 'show-more';
export var showLess = 'show-less';
export var cardClick = 'card-click';